import _ from 'lodash'
const saleQuote = {
  list: [],
  saleQuote: [],
  saleQuoteListLoading: false,
  saleQuoteItemsLoading: false,
  saleQuotePricingLoading: false,
  submitQuoteLoading: false,
  approvalQuoteLoading: false,
  isSaleQuoteNotesModal: false,
  saleQuoteNotesModalLoading: false,
  archiveLoading: false,
  deleteQuoteBtnLoading: false,

  item: {},
}
const SaleQuoteReducer = function (state = saleQuote, action) {
  switch (action.type) {
    case 'SET_CUSTOMERS_LIST': {
      return {
        ...state,
        list: action.list,
      }
    }

    case 'SET_SALE_QUOTE_LIST': {
      return {
        ...state,
        saleQuote: action.list,
      }
    }
    case 'SET_SALE_QUOTE': {
      return {
        ...state,
        item: action.item,
      }
    }
    case 'TOGGLE_SALE_QUOTE_LIST_LOADING': {
      return {
        ...state,
        saleQuoteListLoading: action.value,
      }
    }
    case 'TOGGLE_SALE_QUOTE_ITEMS_LOADING': {
      return {
        ...state,
        saleQuoteItemsLoading: action.value,
      }
    }
    case 'TOGGLE_SALE_QUOTE_PRICING_LOADING': {
      return {
        ...state,
        saleQuotePricingLoading: action.value,
      }
    }
    case 'TOGGLE_SUBMIT_QUOTE_LOADING': {
      return {
        ...state,
        submitQuoteLoading: action.value,
      }
    }
    case 'TOGGLE_APPROVAL_QUOTE_LOADING': {
      return {
        ...state,
        approvalQuoteLoading: action.value,
      }
    }
    case 'TOGGLE_APPROVAL_QUOTE_LOADING': {
      return {
        ...state,
        approvalQuoteLoading: action.value,
      }
    }
    case 'TOGGLE_SALE_QUOTE_NOTES_MODAL': {
      return {
        ...state,
        isSaleQuoteNotesModal: action.value,
      }
    }
    case 'TOGGLE_ARCHIVE_LOADING': {
      return {
        ...state,
        archiveLoading: action.value,
      }
    }
    case 'TOGGLE_DELETE_LOADING': {
      return {
        ...state,
        deleteQuoteBtnLoading: action.value,
      }
    }
    default: {
      return state
    }
  }
}

export default SaleQuoteReducer
